import { render, staticRenderFns } from "./CopyToClipboardBtn.vue?vue&type=template&id=79a8a9b3&scoped=true"
import script from "./CopyToClipboardBtn.vue?vue&type=script&lang=js"
export * from "./CopyToClipboardBtn.vue?vue&type=script&lang=js"
import style0 from "./CopyToClipboardBtn.vue?vue&type=style&index=0&id=79a8a9b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a8a9b3",
  null
  
)

export default component.exports